export default "__VITE_ASSET__X_9I8duB__"